<ng-container *ngIf="categoriesAndButtons.length > 0">
  <div [ngClass]="categoriesAndButtons.length < 4 ? 'container-md' : ''">
    <div [ngClass]="categoriesAndButtons.length < 4 ? 'row' : ''">
      <div class="banner__content col-12 margin-10" [ngClass]="{
          'banner-with-four-columns': categoriesAndButtons.length === 4,
          'col-lg-9': categoriesAndButtons.length === 2,
          'col-lg-4': categoriesAndButtons.length === 1
        }">
        <div class="row">
          <div class="banner__actions col-12 margin-10" [ngClass]="{
            'col-lg-3': categoriesAndButtons.length === 4,
            'col-lg-4': categoriesAndButtons.length === 3,
            'col-md-6': categoriesAndButtons.length === 2
          }" *ngFor="let categorie of categoriesAndButtons; index as i">
            <div
              [ngClass]="!categorie.show ? 'banner__sub banner__sub--inactive d-flex align-items-start' : 'banner__sub banner__sub--active d-flex align-items-start'"
              (click)="toggle(i)">
              <img class="mr-2 correct-icon-position" [src]="categorie.icon" alt="">
              <h3 class="pt-1" style="width: 100%; flex: 1">
                <div style="position: relative; flex: 1, width: 100%; height: 0px;">
                  <div style="position: absolute; width: 100%">
                    {{categorie.title}}
                  </div>
                </div>
                &nbsp;
              </h3>
            </div>
            <div [ngClass]="!categorie.show ? 'animation-container--closed' : ''" class=" animation-container ">
              <div class="banner__list banner__list--show">
                <div *ngFor="let action of categorie.actionButtons" class="banner__action mt-2"
                  [routerLink]="action.link">

                  <h5>
                    <span class="button-title">{{action.name}}</span>
                    <ng-container *ngIf="requestApproverPendingReview && requestApproverPendingReview > 0 && action.showPending">
                      <span class="circle circle-fake">
                        0
                      </span>
                      <span class="circle circle-real">
                        {{requestApproverPendingReview}}
                      </span>
                    </ng-container>
                  </h5>
                  <p>{{action.description}}<p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
